/**
 * Экран загрузки.
 *
 * Показывается при проверке сессии и ленивой загрузке страниц.
 * Намеренно без спиннера-«вертушки»: вместо него пульсирующая
 * маршрутная линия — тот же визуальный язык, что и в остальном интерфейсе.
 */

import { Navigation } from 'lucide-react';

export function LoadingScreen({ label = 'Загрузка' }: { label?: string }) {
  return (
    <div
      className="flex h-full min-h-screen flex-col items-center justify-center gap-5"
      role="status"
      aria-live="polite"
    >
      <div className="relative">
        <span className="absolute inset-0 animate-gps-pulse rounded-full bg-lime/35" />
        <span className="relative flex h-11 w-11 items-center justify-center rounded-full border border-lime/40 bg-lime-dim">
          <Navigation className="h-5 w-5 text-lime" aria-hidden />
        </span>
      </div>

      <div className="flex flex-col items-center gap-2">
        <p className="stat-label">{label}</p>
        <div className="h-px w-32 overflow-hidden bg-edge">
          <div className="h-full w-1/3 animate-breathe bg-lime" />
        </div>
      </div>
    </div>
  );
}

/** Компактный индикатор для встраивания в карточки. */
export function InlineLoader({ label }: { label?: string }) {
  return (
    <div className="flex items-center gap-2.5 text-muted" role="status" aria-live="polite">
      <span className="flex h-2 w-2">
        <span className="h-2 w-2 animate-breathe rounded-full bg-lime" />
      </span>
      <span className="text-sm">{label ?? 'Загрузка'}</span>
    </div>
  );
}
